import { Edge } from 'reactflow';
import { NodeWithData } from 'assets/js/pages/engage/workflows/utils/types';
import ELK, { LayoutOptions } from 'elkjs/lib/elk.bundled.js';

const elk = new ELK();
const layoutOptions: LayoutOptions = {
    'elk.algorithm': 'elk.mrtree',
    'elk.direction': 'DOWN',
    'elk.spacing.nodeNode': '80',
};

const getElkLayoutedElements = async (nodes: NodeWithData[], edges: Edge[]) => {
    const graph = {
        id: 'root',
        layoutOptions,
        children: nodes.map(node => ({
            id: node.id,
            width: node.width ?? 0,
            height: node.height ?? 0,
            targetPosition: 'bottom',
            sourcePosition: 'top',
            properties: {
                selected: node.selected,
            },
        })),
        edges: edges.map(edge => ({
            id: edge.id,
            sources: [edge.source],
            targets: [edge.target],
        })),
    };

    const layout = await elk.layout(graph);

    const layoutedNodes = nodes.map((node, index) => {
        const child = layout.children?.at(index);
        return {
            ...node,
            position: {
                x: child?.x ?? 0,
                y: child?.y ?? 0,
            },
            style: { opacity: 1 },
        };
    });

    const layoutedEdges = edges.map(edge => ({ ...edge, style: { opacity: 1 } }));

    return { layoutedNodes, layoutedEdges };
};

export { getElkLayoutedElements };
